var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.69 91.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.43,64.82C106.11,64,79.54,11.38,79.1,10.66a17.33,17.33,0,1,0-30.84,15.6C48.58,27,74,77.44,74.45,78.17a19.12,19.12,0,0,0,1.14,2.26,17.33,17.33,0,1,0,30.84-15.61Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,29.18A17.33,17.33,0,1,0,48.89,7.42C48.32,8,5.17,61.21,4.69,61.9A17.33,17.33,0,1,0,31.54,83.66C32.11,83.05,75.26,29.87,75.74,29.18Z",
    fill: "#7189ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,29.18A17.33,17.33,0,1,0,123.15,7.42C122.58,8,79.43,61.21,79,61.9A17.33,17.33,0,1,0,105.8,83.66C106.37,83.05,149.52,29.87,150,29.18Z",
    fill: "#7189ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoN);
export default __webpack_public_path__ + "static/media/logo-n.b6a576a6aec864bbede9d077f70c438f.svg";
export { ForwardRef as ReactComponent };